import React from 'react';
import PropTypes from 'prop-types';

// components
import LxCard from './LxCard';

// styles
import '../styles.scss';

function CardGroup(props) {
  const { items, id } = props;
  const label = id + String.fromCharCode(id.charCodeAt(0) + 32);
  const styleInlineContent = `#${id}:after { content: "${label}"; }`;
  const itemsContainerPlus = () => items.filter((item, index) => index >= 2)
    .map(item => <LxCard key={item.id} item={item} />);
  return (
    <React.Fragment>
      <style dangerouslySetInnerHTML={{
                    __html: [
                        styleInlineContent,
                        // '}',
                    ],
                }}
      />
      <div
        className="itemsGroup"
        id={id}
      >
        <ul className={items.length === 1 ? 'itemsContainer center' : 'itemsContainer'} >
          {items.length === 1 && <LxCard item={items[0]} /> }
          {items.length > 1 && <LxCard item={items[0]} />}
          {items.length > 1 && <LxCard item={items[1]} />}
        </ul>
        {items.length > 2 &&
        <ul className="itemsContainer">
          {itemsContainerPlus()}
        </ul>}
      </div>
    </React.Fragment>
  );
}
CardGroup.propTypes = {
  items: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
};
export default CardGroup;



// WEBPACK FOOTER //
// ./src/app/components/pages/lexique/lexiqueResults/parts/CardGroup.js